// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3ijRc","col":"styles_col__RXvCG","fulfillmentStatus":"styles_fulfillmentStatus__2siSN","emailCol":"styles_emailCol__1taWj"};